module.exports = __webpack_public_path__ + "img/tommy_margarita.cae8d3ae.jpg";